module.exports = __webpack_public_path__ + "static/d-AGarcia-fd9fc62609455c58d29e11f7ed69d1b8.jpg";